// GTM Configuration from environment
function initGTM() {
  const gtmConfig = window.GTM_CONFIG;
  
  if (!gtmConfig) {
    console.warn('GTM_CONFIG not found');
    return;
  }
  
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = gtmConfig.baseUrl + "/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", gtmConfig.containerId);
}

// Initialize GTM when config is available
if (window.GTM_CONFIG) {
  initGTM();
} else {
  // Wait for config to be loaded
  document.addEventListener('DOMContentLoaded', function() {
    if (window.GTM_CONFIG) {
      initGTM();
    }
  });
}